import React, { Component } from 'react';
import './App.css';
import CAFFENIO from './assets/images/CAFFENIO_white.svg';
import BARRAS from './assets/images/ANDATTI.svg';
import { Layout, Icon } from 'antd';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { checkToken } from './util/generics';
import Menu from './components/Menu/Menu';
import Routes from './components/Routes/Routes';
// import Home from './components/Home/Home';
import Login from './components/Login/Login';
import roles from './util/strings/roles';

const { Header, Sider, Content } = Layout;

class App extends Component {
  state = {
    collapsed: false,
    mobile: false,
    loggedIn: false
  };

  toggle = () => {
    this.setState({ collapsed: !this.state.collapsed });
  }

  componentDidMount() {
    this.changeCollapseWidth();
    window.addEventListener("resize", this.changeCollapseWidth);

    if (checkToken()) {
      this.setState({ loggedIn: true })
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.changeCollapseWidth);

  }

  changeCollapseWidth = () => {
    let state = { ...this.state }
    let width = window.innerWidth;

    state.collapsed = false
    state.mobile = false

    if (width <= 800) {
      state.collapsed = true
      state.mobile = true
    }

    this.setState(state)
  }

  logout = () => {
    window.location.replace("/inicio")
    localStorage.clear()
  }

  render() {
    return (
      <Router>
        <Switch>
          {
            this.state.loggedIn
              ? (
                <React.Fragment>
                  <Header style={{ background: '#6e6969', padding: 0 }}>
                    <Icon
                      className="trigger"
                      type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                      onClick={this.toggle}
                    />
                    <div className="tooltip-on">{this.state.collapsed ? "Mostrar menú" : "Ocultar menú"}</div>
                    <figure style={{ height: "55px", display: "inline-block" }}>
                      { [roles.BARISTA, roles.ASESOR, roles.AUDITOR].includes(localStorage.getItem("role"))
                        ? <img className="logo" src={BARRAS} alt="Andatti Barras" style={{ paddingBottom: "20px", paddingTop: "5px"}} />
                        : <img className="logo" src={CAFFENIO} alt="CAFFENIO" style={{ padding: "10px"}}/>
                      }
                    </figure>

                  </Header>
                  <Layout style={{ minHeight: '100vh' }}>
                    <Sider
                      breakpoint="lg"
                      {...(this.state.mobile ? { collapsedWidth: "0" } : {})}
                      trigger={null}
                      width={250}
                      style={{ background: "#FFF" }}
                      collapsible
                      collapsed={this.state.collapsed}
                    >
                      <p style={{ color: "black", textAlign: "center", fontSize: "22px", marginTop: "15px" }}>{this.state.collapsed ? "PSD" : "Pedido Sugerido"}</p>

                      <Menu
                        logout={this.logout}
                        collapsed={this.state.collapsed}
                        toggle={this.toggle}
                      />

                    </Sider>
                    <Layout>
                      <Content style={{
                        margin: '24px 16px', padding: 24, background: '#fff', minHeight: 280,
                      }}
                      >

                        <Routes />

                      </Content>
                    </Layout>
                  </Layout>
                </React.Fragment>
              )
              : <Login />
          }
        </Switch>
      </Router>
    );
  }
}

export default App;
